import { render, staticRenderFns } from "./UserAssetPhones.vue?vue&type=template&id=6e36b9f8"
import script from "./UserAssetPhones.vue?vue&type=script&lang=js"
export * from "./UserAssetPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e36b9f8')) {
      api.createRecord('6e36b9f8', component.options)
    } else {
      api.reload('6e36b9f8', component.options)
    }
    module.hot.accept("./UserAssetPhones.vue?vue&type=template&id=6e36b9f8", function () {
      api.rerender('6e36b9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assets/UserAssetPhones.vue"
export default component.exports